module.exports = __webpack_public_path__ + "img/porschebg.ad6e79a2.png";